import { useSelector } from 'react-redux';
import NewContactsModal from '../PerformanceModals/variants/NewContactsModal';
import InquiriesReceivedModal from '../PerformanceModals/variants/InquiriesReceivedModal';
import DoneVisitsModal from '../PerformanceModals/variants/DoneVisitsModal';
import ConversionTimeModal from '../PerformanceModals/variants/ConversionTimeModal';
import ResponseTimeModal from '../PerformanceModals/variants/ResponseTimeModal';
import AddedPropertiesModal from '../PerformanceModals/variants/AddedPropertiesModal';
import ConversionRateModal from '../PerformanceModals/variants/ConversionRateModal';
import ConcretedOperationsModal from '../PerformanceModals/variants/ConcretedOperationsModal';
import PropertyConsultationsModal from '../PerformanceModals/variants/PropertyConsultationsModal';
import DevelopmentConsultationsModal from '../PerformanceModals/variants/DevelopmentConsultationsModal';
import ClosedLeadsModal from '../PerformanceModals/variants/ClosedLeadsModal';
import ReservationsCreatedModal from '../PerformanceModals/variants/ReservationsCreatedModal';
import ProductionRateModal from '../PerformanceModals/variants/ProductionRateModal';
import DoneEventsModal from '../PerformanceModals/variants/DoneEventsModal';

export default function ModalsProvider({ children }) {
  const { performanceModals } = useSelector((state) => state.DashboardSlice);

  return (
    <>
      {performanceModals.newContacts.isOpen && <NewContactsModal />}
      {performanceModals.inquiriesReceived.isOpen && <InquiriesReceivedModal />}
      {performanceModals.doneVisits.isOpen && <DoneVisitsModal />}
      {performanceModals.doneEvents.isOpen && <DoneEventsModal />}
      {performanceModals.conversionTime.isOpen && <ConversionTimeModal />}
      {performanceModals.responseTime.isOpen && <ResponseTimeModal />}
      {performanceModals.addedProperties.isOpen && <AddedPropertiesModal />}
      {performanceModals.conversionRate.isOpen && <ConversionRateModal />}
      {performanceModals.concretedOperations.isOpen && (
        <ConcretedOperationsModal />
      )}
      {performanceModals.propertyConsultations.isOpen && (
        <PropertyConsultationsModal />
      )}
      {performanceModals.developmentConsultations.isOpen && (
        <DevelopmentConsultationsModal />
      )}
      {performanceModals.closedLeads.isOpen && <ClosedLeadsModal />}
      {performanceModals.reservationsCreated.isOpen && (
        <ReservationsCreatedModal />
      )}
      {performanceModals.productionRate.isOpen && <ProductionRateModal />}

      {children}
    </>
  );
}
